import React from 'react';

export interface Props {
  unreadCount: number;
}

export const UnreadCountBubble = ({ unreadCount }: Props): JSX.Element => (
  <span>
    <span className='invisible md:visible absolute -top-1 right-0 rounded-full bg-tangerine h-4 w-4 text-white text-xs'>
      {unreadCount}
    </span>
    <span className='visible md:invisible absolute -top-2 right-0 text-lg rounded-full text-tangerine'>&#9679;</span>
  </span>
);
